export default __webpack_public_path__ + "static/media/image2.170c4c22.jpg";